import PubSub from "underpub-js";

var EmbedSpotlight = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-EmbedSpotlight',
	};

	$.extend(true, this.options, options);

};

EmbedSpotlight.prototype.init = function() {

	var self = this;

};

export default EmbedSpotlight;
